import {
  insertK1TagManage,
  updateK1TagManage,
  delK1TagManageInfo,
  queryStoreList,
  queryTagManagePage,
  k1ImportTagStoreInfo
} from "@/graphql/tagManager.gql";
import { filterNodeData } from "@root/lib/utils";
export default {
  namespaced: true,
  state: {
    dataList: [],
    storeListData: []
  },
  getters: {},
  actions: {
    async getTagList({ rootState, commit }, data) {
      let {
        data: {
          res: {
            dataList,
            pageInfo: { totalCount: total }
          }
        }
      } = await rootState.gql.query({
        query: queryTagManagePage,
        variables: data
      });
      commit("setDataList", dataList);
      return { total };
    },
    async queryStoreList({ rootState, commit }, data) {
      let {
        data: {
          res: { dataList }
        }
      } = await rootState.gql.query({
        query: queryStoreList,
        variables: data
      });
      commit("setStoreDataList", dataList);
    },

    async addTag({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: insertK1TagManage,
        variables: data
      });
    },
    async updateTag({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: updateK1TagManage,
        variables: data
      });
    },
    async deleteTag({ rootState, commit }, data) {
      await rootState.gql.mutate({
        mutation: delK1TagManageInfo,
        variables: data
      });
    },
    async k1ImportTagStoreInfo({ rootState, commit }, data) {
      let res = await rootState.gql.mutate({
        mutation: k1ImportTagStoreInfo,
        variables: data
      });
      return res;
    }
  },
  mutations: {
    setDataList(state, data) {
      //   let v = filterNodeData(data);
      //   let d = v.map(({ storeList = [], ...others }) => {
      //     return {
      //       storeList: storeList.map(i => i.storeCode),
      //       ...others
      //     };
      //   });
      state.dataList = filterNodeData(data);
    },
    setStoreDataList(state, data) {
      state.storeListData = filterNodeData(data);
    }
  }
};
